// extracted by mini-css-extract-plugin
export var content = "_cx-3";
export var list = "_cx-4";
export var settingsContent = "_cx-7";
export var settingsPanel = "_cx-8";
export var state = "_cx-6";
export var triggerBadge = "_cx-2";
export var triggerButton = "_cx-1";
export var triggerShell = "_cx-0";
export var unreadDot = "_cx-5";